<div class="auth-form">
  <div class="mt-150">
    <span class="title title--big">Пароль успешно изменен</span>
  </div>
  <div class="mt-32">
    <div class="color-blue-dark">Вы можете войти в систему с новым паролем.</div>
    <div class="mt-32">
      <a routerLink="{{ '/' + AUTH_PATHS.login }}" class="link link--blue-dark" id="appReturnToAuth">Вернуться к авторизации</a>
    </div>
  </div>
</div>
